$(document).ready(function() {
  $(".js-admin-pay-period-subscription").change(function() {
    var value = $(this).find("option:selected").attr("value");
    switch (value) {
      case "yearly":
        $('.js-admin-yearly-coupons').removeClass('hidden');
        $('.js-admin-monthly-coupons').addClass('hidden');
        break;
      case "monthly":
        $('.js-admin-yearly-coupons').addClass('hidden');
        $('.js-admin-monthly-coupons').removeClass('hidden');
        break;
    }
  });
});
